import React from 'react'
import ExpenseCheckbox from './ExpenseCheckbox'
import ExpenseInputBox from './ExpenseInputBox'

class ExpenseRow extends React.Component {
  state = {
    invalid: false,
    lastValue: '0',
  }

  hasValue(value) {
    return value !== '' && value !== null && value !== undefined
  }

  handleInput = (event) => {
    const { onChange } = this.props
    let { value } = event.target
    const { invalid } = this.state

    if (value.length > 1 && value.startsWith('0')) {
      value = value.substr(1)
    }

    if (invalid) {
      this.setInvalid(false)
    }

    onChange(value)
  }

  setInvalid(invalid) {
    const { text, onInvalid} = this.props
    this.setState({ invalid })
    onInvalid({ text, invalid })
  }

  inputDisabled() {
    return this.props.disabled
  }

  inputId() {
    return this.props.id + '-' + this.props.iconName
  }

  checkboxId() {
    return this.inputId() + '-checkbox'
  }

  invalidChecked(value) {
    return this.props.checked && value === '0' ? 'invalid' : ''
  }

  render() {
    const {
      text,
      iconName,
      errorMessage,
      value,
      disabled,
      focusedInput,
      handleFocusedInput,
      handleBlurredInput,
    } = this.props

    const { lastValue } = this.state

    const displayValue = (value || null)
    const invalidClass = this.invalidChecked(displayValue)

    return (
      <div className={ `expense-row d-flex justify-content-between ${ invalidClass }` }>
        <ExpenseCheckbox
          id={ this.inputId() }
          focusedInput={ focusedInput }
          iconName={ iconName }
          text={ text }
          handleFocusedInput={handleFocusedInput}
          handleBlurredInput={handleBlurredInput}
        />

        <div className='expense-form-group form-group'>
          <ExpenseInputBox
            id={ this.inputId() }
            disabled={ this.inputDisabled() }
            errorMessage={ errorMessage }
            onChange={ this.handleInput }
            value={ displayValue }
            inputMode='numeric'
            focusedInput={ focusedInput }
            handleFocusedInput={handleFocusedInput}
            handleBlurredInput={handleBlurredInput}
          />
        </div>
      </div>
    )
  }
}

export default ExpenseRow
